import {
  useMutation,
  useQueryClient,
  UseMutateFunction,
} from "@tanstack/react-query";

import axios, { AxiosResponse } from "axios";
import { toast } from "@punchup/ui-common/shadcn/ui/use-toast";
import { useTixologi } from "@punchup/data/legacy/hooks";
import { tixologiUrl } from "../../api-base";
import { TICKET_FEE_DEFAULTS_QUERY_KEY } from "./useTicketFeeDefaults";

type UseDeleteTicketFeeDefaultsReturn = {
  mutate: UseMutateFunction<AxiosResponse, Error, void, unknown>;
  isPending: boolean;
  isSuccess: boolean;
  error: Error | null;
};

export function useDeleteTicketFeeDefaults({
  venuePageId,
}: {
  venuePageId: string;
}): UseDeleteTicketFeeDefaultsReturn {
  const { tixologiData } = useTixologi({ id: venuePageId, isComedian: false });
  const queryClient = useQueryClient();

  const { mutate, isPending, isSuccess, error } = useMutation({
    mutationFn: async (): Promise<AxiosResponse> =>
      axios.delete(tixologiUrl("/ticket_types/fee-defaults"), {
        headers: { Authorization: `Bearer ${tixologiData?.token}` },
      }),
    onSuccess: () => {
      toast({ title: "Default ticket fees removed", variant: "success" });
      queryClient.invalidateQueries({
        queryKey: [TICKET_FEE_DEFAULTS_QUERY_KEY, venuePageId],
        refetchType: "active",
      });
    },
    onError: (error) => {
      toast({
        title: "Error removing the default ticket fees",
        description: error.message || "Something went wrong",
        variant: "destructive",
      });
    },
  });

  return { mutate, isPending, isSuccess, error };
}
